import React from "react";
import { useTranslation } from 'react-i18next';
import {
    Checkbox,
} from '@workboard/wobo-ui';

import { imgUrl } from '../../../utils/url';

const WsAccessComp = (props: any) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
              {props.teamList.length > 0 &&
                        (
                            <div className="ws-team-list">
                                <h6 className="ws-team-title">{t('Teams with access to this workstream')}:</h6>
                                {
                                    props.teamList.map(item => {
                                        return (
                                            <div key={item.teamId}>
                                                <div className="ws-team-body">
                                                    <div>
                                                        <span className="icon icon-outline-people-24px"></span>
                                                        <span className="team-name">{item.teamName}</span>
                                                    </div>
                                                    <div className="wsIncludedTeamsDeleteDiv" onClick={() => props.handleRemoveTeam(item.teamId)}>
                                                        <img className="closeX" src={imgUrl('/images/ai-v1-assets/x.png')} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }

            <div className="ws-permission-list-section">
                <div className="display-flex">
                    <div><p className="fontBold">{t('People with access to this workstream')}:</p></div>
                    <div><Checkbox  isChecked={props.selectAllCheck} className="ws-checkbox-custom" onChange={(e: any) => props.handleselectAll(e)} label={t("Select all")} /></div>
                </div>
                <div className="ws-permission-list">
                    {
                        props.wsAccessList.length > 0 ?
                            <ul className="ws-permission-list-ul">
                                {
                                    props.wsAccessList.map(
                                        (item, index) => {
                                            return (<li key={item.userId}>
                                                <Checkbox
                                                    id={"user_access" + item.userId}
                                                    isChecked={item.isChecked}
                                                    onChange={() => props.handleAccesChange(item.userId)}
                                                    className="user-list-checkbox"
                                                    label={
                                                        <React.Fragment>
                                                            <span className="ws-avatar">
                                                                {
                                                                    item.userPic ?
                                                                        <img className="ws-avatar__image" src={item.userPic} alt="avatar" /> :
                                                                        <span className="icon icon-outline-people-24px"></span>
                                                                }
                                                            </span>
                                                            <span className="fullname">{item.label}</span>
                                                        </React.Fragment>
                                                    }
                                                />
                                            </li>)
                                        }
                                    )
                                }
                            </ul> : ''
                    }
                </div>

                <div className="marginTop15">
                    <Checkbox id="auto-checked" className="ws-checkbox-custom" isChecked={props.autoSelect} onChange={props.handleAutoSelect} label={t("Auto-share this Workstream with new team members")} />
                </div>
            </div>
        </React.Fragment >
    );
};
export default WsAccessComp;